function rem(px: number, defaultRem = 16) {
  return `${px / defaultRem}rem`;
}

export default rem;
